// Code starts here

$(document).ready(function () {
  console.log('hello');
});

gsap.registerPlugin(ScrollTrigger);
ScrollSmoother.create({
	smooth: 1,
	effects: true
});

// gsap.registerPlugin(ScrollTrigger);
// const navbar = document.querySelector(".component_navbar_section");
// const menuLines = document.querySelectorAll(".component_navbar_menu_line");
// // store original colors so we can revert cleanly
// const originalTextColor = getComputedStyle(navbar).color;
// const originalLineColor = getComputedStyle(menuLines[0]).backgroundColor;
// ScrollTrigger.create({
//   trigger: ".page-wrapper",
//   start: "top top",
//   onEnter: () => {
//     gsap.to(navbar, {
//       backgroundColor: "#e2e2cf",
//       color: "#0a242b",
//       duration: 0.3
//     });
//     gsap.to(menuLines, {
//       backgroundColor: "#0a242b",
//       duration: 0.3
//     });
//   },
//   onLeaveBack: () => {
//     gsap.to(navbar, {
//       backgroundColor: "transparent",
//       color: originalTextColor,
//       duration: 0.3
//     });
//     gsap.to(menuLines, {
//       backgroundColor: originalLineColor,
//       duration: 0.3
//     });
//   }
// });

gsap.registerPlugin(ScrollTrigger);
const navbar = document.querySelector(".component_navbar_section");
const originalTextColor = getComputedStyle(navbar).color;

ScrollTrigger.create({
  trigger: ".page-wrapper",
  start: "top top",

  onEnter: () => {
    gsap.to(navbar, {
      backgroundColor: "#e2e2cf",
      color: "#0a242b",
      duration: 0.3
    });
  },

  onLeaveBack: () => {
    gsap.to(navbar, {
      backgroundColor: "transparent",
      color: originalTextColor,
      duration: 0.3
    });
  }
});

const initSlider = (identifier, config) => {
  const sliderElement = document.querySelector(identifier);
  const { parentNode, dataset: { breakpoint } } = sliderElement;
  const paginationTypes = ["bullets", "progressbar", "fraction"];
  if (paginationTypes.some((type) => type === config.pagination)) {
    const { id } = parentNode.querySelector(".swiper-pagination");
    const paginationConfig = { el: `#${id}`, type: config.pagination };
    if (config.pagination === "bullets") {
      const { className } = parentNode.querySelector(
        ".swiper-pagination-bullet"
      );
      paginationConfig.bulletClass = className.replace(
        "swiper-pagination-bullet-active",
        ""
      );
      paginationConfig.clickable = true;
    }
    if (config.pagination === "progressbar") {
      const { className } = parentNode.querySelector(
        ".swiper-pagination-progressbar-fill"
      );
      paginationConfig.progressbarFillClass = className;
    }
    config.pagination = paginationConfig;
  }
  if (config.navigation === true) {
    const { id: prevId } = parentNode.querySelector(".swiper-button-prev");
    const { id: nextId } = parentNode.querySelector(".swiper-button-next");
    config.navigation = { prevEl: `#${prevId}`, nextEl: `#${nextId}` };
  }
  if (config.scrollbar === true) {
    const { id } = parentNode.querySelector(".swiper-scrollbar");
    config.scrollbar = { el: `#${id}`, draggable: true };
  }
  let slider = null;
  if (breakpoint) {
    const resolvedBreakpoint = parseInt(breakpoint);
    const runOnMatch = (media) => {
      if (media.matches && !slider) {
        config.init = false;
        slider = new Swiper(identifier, config);
        slider.init();
      }
      if (!media.matches && slider) {
        slider.destroy();
        slider = null;
      }
    };
    const media = window.matchMedia(
      `only screen and (${resolvedBreakpoint >= 0 ? "min" : "max"}-width: ${
        resolvedBreakpoint >= 0 ? resolvedBreakpoint : resolvedBreakpoint * -1
      }px)`
    );
    runOnMatch(media);
    window.addEventListener("resize", () => {
      runOnMatch(media);
    });
    media.addEventListener("change", runOnMatch);
  } else {
    slider = new Swiper(identifier, config);
  }
};
const resolveSliderHeight = (swiper) => {
  const { params, slides, el } = swiper;
  const { direction, slidesPerView, loop, spaceBetween } = params;
  if (direction && direction === "vertical") {
    const activeIndex = swiper[loop ? "realIndex" : "activeIndex"];
    const resolvedSlidesPerView = parseInt(slidesPerView) || 1;
    const currentSlideLimit = activeIndex + resolvedSlidesPerView;
    let height = 0;
    for (let i = activeIndex; i < currentSlideLimit; i++) {
      if (slides[i]) {
        height += slides[i].offsetHeight;
      }
    }
    if (spaceBetween && resolvedSlidesPerView > 1) {
      height += (spaceBetween * resolvedSlidesPerView);
    }
    el.style.height = height > 0 ? `${height}px` : "auto";
  }
};
const initSliderTransformSwitchers = (swiper) => {
  const { el, slides, wrapperEl } = swiper;
  if (!el.classList.contains("init-slider-transform-switchers")) {
    el.classList.add("init-slider-transform-switchers");
    slides.forEach((slide) => {
      const switchers = slide.querySelectorAll("[data-slider_transform]");
      if (switchers.length > 0) {
        switchers.forEach((switcher) => {
          switcher.addEventListener("click", () => {
            const { slider_transform } = switcher.dataset;
            if (slider_transform === "off") {
              slide.classList.add("transform-none");
              wrapperEl.classList.add("transform-none");
            } else {
              slide.classList.remove("transform-none");
              wrapperEl.classList.remove("transform-none");
            }
          });
        });
      }
    });
  }
};
const forceLastSlideActive = (swiper) => {
  swiper.snapGrid = [...swiper.slidesGrid];
};
const toggleSlideOverlays = (swiper) => {
  const overlays = swiper.el.querySelectorAll("[data-slide='overlay']");
  overlays.forEach((overlay) => {
    overlay.classList.toggle("hide");
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const a = document.querySelector("#video-slider");
  if(a) {
    initSlider("#video-slider", {
      slidesPerView: "auto",
      speed: 700,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      breakpoints: {
        0: {
          slidesPerView: "auto",
          spaceBetween: 16
        },
        992: {
          slidesPerView: "auto",
          spaceBetween: 24
        }
      },
      on: {
        init: function () {
          // Apply active class on load
          this.slides[this.activeIndex].classList.add("is-active");
        },
        slideChange: function () {
          // Remove active class from all slides
          this.slides.forEach(slide => {
            slide.classList.remove("is-active");
          });
          // Add active class to the current slide
          this.slides[this.activeIndex].classList.add("is-active");
        }
      }
    });
  }
});

const videoCards = document.querySelectorAll('.component_values_video_wrapper');
videoCards.forEach(card => {
  const video = card.querySelector('video');
  const playButton = card.querySelector('.component_video-slider_play-button');
  // Play video on overlay button click
  playButton.addEventListener('click', () => {
    video.play();
    video.setAttribute('controls', '');  // Show browser controls
    playButton.style.display = 'none';   // Hide overlay
  });
  // Reset video when it ends
  video.addEventListener('ended', () => {
    video.removeAttribute('controls');   // Hide controls
    playButton.style.display = 'flex';   // Show overlay
    video.currentTime = 0;               // Reset video
    video.load();                        // Restore poster
  });
});

// gsap.registerPlugin(ScrollTrigger);
// ScrollTrigger.matchMedia({
//   "(min-width: 992px)": function () {
//     const component = document.querySelector(".home_feature_component");
//     const cards = gsap.utils.toArray(".home_feature_item");
//     if (!component || !cards.length) return;
//     const lastCard = cards[cards.length - 1];
//     // 1&#65039;&#8419; Pin the main component for the duration of all cards
//     ScrollTrigger.create({
//       trigger: component,
//       start: "top top",
//       endTrigger: lastCard,
//       end: "bottom bottom",
//       pin: true,
//       pinSpacing: true,
//     });
//     // 2&#65039;&#8419; Pin each card individually while the component is pinned
//     cards.forEach((card, index) => {
//       ScrollTrigger.create({
//         trigger: card,
//         start: "top top",
//         endTrigger: lastCard,
//         end: "top top",
//         pin: true,
//         pinSpacing: index === cards.length - 1,
//       });
//     });
//   },
// });

document.addEventListener('DOMContentLoaded', () => {
  const b = document.querySelector("#is-testimonials");
  if(b) {
    initSlider("#is-testimonials", {
      slidesPerView: 2,
        speed: 500,
      spaceBetween: 8,
        slidesPerView: 1,
        navigation: {
          nextEl: '#testimonial-next',
          prevEl: '#testimonial-prev',
          disabledClass: "is-disabled",
        },
      pagination: {
       el: '#is-testimonial-pagination',
          bulletActiveClass: "is-active",
          bulletClass: "component_slider-dot",
       type: 'bullets',
          clickable: true
      }
     });
  }
});

/*
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".swiper-slide.is-testimonials");
  const loadMoreBtn = document.getElementById("load-more");

  if (!loadMoreBtn) return; // Safety check

  const INITIAL_COUNT = 6;
  const LOAD_COUNT = 3;
  let visibleCount = INITIAL_COUNT;

  // Show initial items
  items.forEach((item, index) => {
    if (index < INITIAL_COUNT) item.classList.add("show");
  });

  // Hide button if all items are already visible
  if (items.length <= INITIAL_COUNT) loadMoreBtn.style.display = "none";

  // Load more on click
  loadMoreBtn.addEventListener("click", function () {
    const nextItems = Array.from(items).slice(visibleCount, visibleCount + LOAD_COUNT);
    nextItems.forEach((item) => item.classList.add("show"));
    visibleCount += LOAD_COUNT;
    if (visibleCount >= items.length) loadMoreBtn.style.display = "none";
  });
});
*/
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".swiper-slide.is-testimonials");
  const loadMoreBtn = document.getElementById("load-more");

  if (!loadMoreBtn) return; // Safety check

  const INITIAL_COUNT = 6;
  const LOAD_COUNT = 3;
  let visibleCount = INITIAL_COUNT;

  // Show initial items
  items.forEach((item, index) => {
    if (index < INITIAL_COUNT) item.classList.add("show");
  });

  // Hide button if all items are already visible
  if (items.length <= INITIAL_COUNT) loadMoreBtn.style.display = "none";

  // Load more on click
  loadMoreBtn.addEventListener("click", function () {
    const nextItems = Array.from(items).slice(visibleCount, visibleCount + LOAD_COUNT);
    nextItems.forEach((item) => item.classList.add("show"));
    visibleCount += LOAD_COUNT;
    if (visibleCount >= items.length) loadMoreBtn.style.display = "none !important";
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const c = document.querySelector("#is-product");
  if(c) {
    initSlider("#is-product", {
      slidesPerView: "auto",
         speed: 500,
         spaceBetween: 16,
         navigation: {
           nextEl: '#product-next',
           prevEl: '#product-prev',
           disabledClass: "is-disabled",
          },
      pagination: {
       el: '#product-pagination',
         bulletActiveClass: "is-active",
         bulletClass: "swiper_dot_product",  
       type: 'bullets',
         clickable: true
      }
     });
  }
});  

document.addEventListener('DOMContentLoaded', () => {
  const d = document.querySelector("#is-story");
  if(d) {
    initSlider("#is-story", {
      slidesPerView: "auto",
        speed: 500,
      spaceBetween: 16,
        navigation: {
          nextEl: '#story-next',
          prevEl: '#story-prev',
          disabledClass: "is-disabled",
          },
      pagination: {
      el: '#story-pagination',
          bulletActiveClass: "is-active",
          bulletClass: "swiper_dot",
      type: 'bullets',
          clickable: true
      }
    });
  }
});

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.matchMedia({
  "(min-width: 992px)": function () {
    const component = document.querySelector(".home_feature_component");
    const cards = gsap.utils.toArray(".home_feature_item");
    if (!component || !cards.length) return;
    const lastCard = cards[cards.length - 1];
    // 1&#65039;&#8419; Pin the main component for the duration of all cards
    ScrollTrigger.create({
      trigger: component,
      start: "top top",
      endTrigger: lastCard,
      end: "bottom bottom",
      pin: true,
      pinSpacing: true,
    });
    // 2&#65039;&#8419; Pin each card individually while the component is pinned
    cards.forEach((card, index) => {
      ScrollTrigger.create({
        trigger: card,
        start: "top top",
        endTrigger: lastCard,
        end: "top top",
        pin: true,
        pinSpacing: index === cards.length - 1,
      });
    });
  },
});

/*
document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);
  let mm = gsap.matchMedia();
  // This code only runs when the screen is 992px or wider
  mm.add("(min-width: 992px)", () => {
    ScrollTrigger.create({
      trigger: ".home_section_wrapper",
      start: "top top",
      end: "bottom top",
      pin: ".home_section_background-image-wrapper",
      pinSpacing: false,
      scrub: false
    });
    // Optional: return a cleanup function if needed
    return () => { 
      // This kills the trigger automatically when screen goes below 992px
    };
  });
});
*/

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  // MatchMedia is optional now, but we can just run ScrollTrigger on all screen sizes
  ScrollTrigger.create({
    trigger: ".home_section_wrapper",
    start: "top top",
    end: "bottom top",
    pin: ".home_section_background-image-wrapper",
    pinSpacing: false,
    scrub: false
  });
});

// Code ends here